var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app is-primary",class:{ 'is-folded': _vm.ISFOLDED, 'is-expand': _vm.ISEXPANDED },attrs:{"id":"app"}},[_c('router-view'),_c('Notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }